import { Button as AntButton, Descriptions, Modal, Table, TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
  }

interface iNotesColumn {
    testType:string,
    part1:string,
    part2:string
}  

const PtStatsByNotesModal = (prop:IProps) => {

    const { t } = useTranslation();

    const getColumns = () => {
        let testColumn: TableColumnsType<iNotesColumn> = [];

        testColumn = [
            {
                title: "Test Type",
                dataIndex: 'testType',
                align: 'center',
            },
            {
                title: "Part 1",
                dataIndex: 'part1',
                align: 'center',
            },
            {
                title: "Part 2",
                dataIndex: 'part2',
                align: 'center',
            },
        ]
        return testColumn;
    }

    let notesRows: Array<iNotesColumn> = new Array<iNotesColumn>;
    notesRows.push({testType:"Type 1",part1:"Visual Speaking 1",part2:"Conversation A"});
    notesRows.push({testType:"Type 2",part1:"Conversation B",part2:"Free Speech 1"});
    notesRows.push({testType:"Type 3",part1:"Conversation C",part2:"Free Speech 2"});
    notesRows.push({testType:"Type 4",part1:"Visual Speaking 2",part2:"Free Speech 2"});

    return(
        <>
            <Modal
                title="Speaking Test"
                onCancel={() => prop.setVisible(false)}
                open={prop.visible}
                footer={[
                    <div className='comm-btn__area justify-content-center'>
                        <AntButton key="cancel" className='btn-basic gray' onClick={() => prop.setVisible(false)}>
                        {t('common.button.close')}
                        </AntButton>
                    </div>
                  ]}
            >
                <div className='comm-table__area mt-0'>
                    <Table
                        columns={getColumns()}
                        dataSource={notesRows}
                    />
                </div>
            </Modal>
        </>
    );
}

export default PtStatsByNotesModal;